export default {
  TWO_INPUTS_IN_ROW: 'Composites.TwoInputsInRow',
  ONE_INPUT_IN_ROW: 'Composites.OneInputInRow',
  INPUT_WITH_SYMBOL_BELOW: 'Composites.InputWithSymbolBelow',
  TWO_INPUTS_WITH_LABEL: 'Composites.TwoInputsWithLabel',
  INPUT_WITH_LABEL_AND_SYMBOL: 'Composites.InputWithLabelAndSymbol',
  INPUT_LABELED: 'Composites.InputLabeled',
  INPUT_WITH_DROP_DOWN: 'Composites.InputWithDropDown',
  INPUT_WITH_DROP_DOWN_LABELED: 'Composites.InputWithDropDownLabeled',
  INPUT_WITH_DROP_DOWN_LABELED_HORIZONTAL: 'Composites.InputWithDropDownLabeledHorizontal',
  INPUT_WITH_DROP_DOWN_LABELED_TOP: 'Composites.InputWithDropDownLabeledTop',
  INPUT_WITH_DROP_DOWN_SYMBOL: 'Composites.InputWithDropDownSymbol',
  COLLAPSE_LABEL_WITH_INFO_ICON: 'Composites.CollapseLabelWithInfoIcon',
  MULTI_INPUT_WITH_DROP_DOWN: 'Composites.MultiInputWithDropDown',
  MULTI_INPUT_WITH_DROP_DOWN_LABELED: 'Composites.MultiInputWithDropDownLabeled',
  MULTI_INPUTS_IN_ROW: 'Composites.MultiInputsInRow',
  DOCKING_CONTROL: 'Composites.DockingControl',
  DOCKING_CONTROL_WITH_LABEL: 'Composites.DockingControlWithLabel',
  ICON_TABS: 'Composites.IconTabs',
  NUMERIC_INPUT: 'Composites.NumericInput',
  NUMERIC_INPUT_LABELED: 'Composites.NumericInputLabeled',
  CHECKBOXES_LABELED: 'Composites.CheckboxesLabeled',
  CHECKBOX_WITH_INFO_ICON: 'Composites.CheckboxWithInfoIcon',
  TEXT_LABEL_WITH_ICON: 'Composites.TextLabelWithIcon',
  TWO_TEXT_LABELS_IN_ROW: 'Composites.TwoTextLabelsInRow',
  DEFAULT_PANEL_PADDING: 'Composites.DefaultPanelPadding',
  DROP_DOWN_LABELED_HORIZONTAL: 'Composites.DropDownLabeledHorizontal',
  DROP_DOWN_LABELED_VERTICAL: 'Composites.DropDownLabeledVertical',
  MULTI_ROWS_OF_TWO_INPUTS_IN_ROW: 'Composites.MultiRowsOfTwoInputsInRow',
  THUMBNAILS_LABELED_HORIZONTAL: 'Composites.ThumbnailsLabeledHorizontal',
  PANEL_FOOTER_BUTTON_WITH_ICON: 'Composites.PanelFooterButtonWithIcon',
  EMPTY_STATE: 'Composites.EmptyState',
  POPUP_CONFIRMATION: 'Composites.PopupConfirmation',
  COMPONENT_PANEL: 'Composites.ComponentPanel',
  INPUT_WITH_MENTIONS: 'Composites.InputWithMentions',
  BUTTON_TEXT_LABEL_AND_ICON_BUTTON_IN_ROW: 'Composites.ButtonTextLabelAndIconButtonInRow'
};